import {useEffect, useState} from "react";


const useImage = (fileName: string | undefined) => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    interface IImageData {
        s : {
            src : string
            size? : number
        }
        m : {
            src : string
            size? : number
        }
        l : {
            src : string
            size? : number
        }
    }

    const [imageData, setImageData] = useState<IImageData | undefined>(undefined)

    // Needs to download the image. So not an optimal solution.
    const getWidth = (url : string) => new Promise<number>(resolve => {
        const img = new Image()
        img.src = url
        img.onload = () => resolve(img.naturalWidth)
    });

    useEffect(() => {
        const fetchImage = async () => {
            try {

                const response_s = (await require(`../../assets/images/${fileName}-s.webp`))
                const response_m = (await require(`../../assets/images/${fileName}-l.webp`))
                const response_l = (await require(`../../assets/images/${fileName}-xl.webp`))

                setImageData(
                {
                        s : {
                            src : response_s,
                            size : undefined //await getWidth(response_s)
                            },
                        m : {
                            src : response_m,
                            size : undefined // await getWidth(response_m)
                        },
                        l : {
                            src : response_l,
                            size : undefined // await getWidth(response_l)
                        }
                    }
                )

            } catch (err: any) {
                setError(err)
            } finally {
                console.log()
                setLoading(false)
            }
        }

        if (fileName !== undefined) {fetchImage()}
    }, [fileName])

    return {
        loading,
        error,
        imageData
    }
}

export default useImage
